module.exports = __webpack_public_path__ + "static/media/ic_phone_36.d048f89b.svg";